module.exports = __webpack_public_path__ + "static/media/about.3e000670.jpg";